import React, { useState, useMemo } from 'react';
import axios from 'axios';
import { APP_API_URL } from '../../../utils';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import DuoModal from '../../../components/ui/duo-modal';
import { useDataContext } from '../../../context/DataContext';

export default function Add({ open, onClose, refreshData }) {
  const user = useSelector((state) => state.auth.user);
  const { categories } = useDataContext([]);

  const [formData, setFormData] = useState({
    nom: '',
    logo: '',
    category_id: '',
    user_id: user?.id,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  const mainCategories = useMemo(
    () => (categories || []).filter((c) => c.type_categorie === null),
    [categories]
  );

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'logo') {
      setFormData({ ...formData, logo: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const resetForm = () => {
    setFormData({ nom: '', logo: '', category_id: '', user_id: user?.id });
    setErrors({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const formDataUpload = new FormData();
      formDataUpload.append('nom', formData.nom);
      formDataUpload.append('user_id', formData.user_id);
      if (formData.category_id) {
        formDataUpload.append('category_id', formData.category_id);
      }
      if (formData.logo) {
        formDataUpload.append('logo', formData.logo);
      }

      const response = await axios.post(`${APP_API_URL}/marques`, formDataUpload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      await Swal.fire({
        icon: 'success',
        title: 'Succès',
        text: response.data.message || 'La marque a été ajoutée avec succès.',
        timer: 2000,
        showConfirmButton: false,
      });

      resetForm();
      onClose();
      refreshData();
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
      }
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: error.response?.data?.message || "Une erreur est survenue.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <DuoModal
      title="Ajouter une marque"
      onClose={handleClose}
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={handleClose} disabled={isLoading}>
            Annuler
          </button>
          <button type="submit" form="add-brand-form" className="duo-btn duo-btn--primary" disabled={isLoading}>
            {isLoading ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </>
      }
    >
      <form id="add-brand-form" onSubmit={handleSubmit}>
        <div className="duo-form-group">
          <label htmlFor="add-brand-nom" className="duo-form-label">
            Nom de la marque *
          </label>
          <input
            type="text"
            className="duo-input"
            id="add-brand-nom"
            name="nom"
            value={formData.nom}
            onChange={handleChange}
          />
          {errors.nom && <p className="text-danger small mt-1 mb-0">{errors.nom[0]}</p>}
        </div>
        <div className="duo-form-group">
          <label htmlFor="add-brand-category" className="duo-form-label">
            Catégorie
          </label>
          <select
            className="duo-select"
            id="add-brand-category"
            name="category_id"
            value={formData.category_id}
            onChange={handleChange}
          >
            <option value="">Sélectionner une catégorie</option>
            {mainCategories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.nom}
              </option>
            ))}
          </select>
          {errors.category_id && <p className="text-danger small mt-1 mb-0">{errors.category_id[0]}</p>}
        </div>
        <div className="duo-form-group mb-0">
          <label htmlFor="add-brand-logo" className="duo-form-label">
            Logo
          </label>
          <input
            type="file"
            accept="image/*"
            className="duo-input"
            id="add-brand-logo"
            name="logo"
            onChange={handleChange}
          />
          {errors.logo && <p className="text-danger small mt-1 mb-0">{errors.logo[0]}</p>}
        </div>
      </form>
    </DuoModal>
  );
}
